import { Inject, Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserServiceInterface } from '@hutsix/ngxh6';

/**
 * Only lets you reach /set-password while you actually owe a password.
 *
 * The route exists for one moment in an account's life - the first sign-in after staff
 * issue a temporary password - so anyone who has already chosen one is either lost or
 * poking at it. Ordinary password changes go through the profile form. The API refuses
 * the same case with a 409; this stops the screen appearing at all.
 */
@Injectable({
    providedIn: 'root',
})
export class SetPasswordGuardService {
    constructor(
        private router: Router,
        @Inject('UserService') public user: UserServiceInterface,
    ) {}

    canActivate(route: unknown, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.user.watch.pipe(
            map(user => {
                if (!user || !user.loggedIn) {
                    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    return false;
                }

                if (!(user as any)?.account?.user?.mustChangePassword) {
                    // Nothing owed. Send them where they would have gone anyway rather
                    // than to an error page - reaching this by a stale link or the back
                    // button is not a fault.
                    this.router.navigate(['/']);
                    return false;
                }

                return true;
            }),
        );
    }
}
